<template>
  <aside class="app-sidebar noprint" :class="{ 'app-sidebar--compact': compact }">
    <button
      type="button"
      class="app-sidebar__toggle"
      :aria-label="compact ? 'Expand sidebar' : 'Collapse sidebar'"
      @click="toggleCompact">
      <i class="fa-solid" :class="compact ? 'fa-chevrons-right' : 'fa-chevrons-left'" />
    </button>

    <div class="app-sidebar__wrapper">
      <ul>
        <SidebarItem
          v-for="item in sidebarItems"
          :key="item.href"
          :item="item"
          :compact="compact"
          @toggle="toggleGroup(item)" />
      </ul>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { SIDEBAR_VIEW_MODE_KEY } from '@/config/sidebars/init'
import { saveToStorage } from '@/helpers/storage'
import SidebarItem from './SidebarItem.vue'

const globalStore = useGlobalStore()

const sidebarItems = computed(() => (globalStore.sidebar?.items || [])
  .filter((item) => !item.show || item.show(globalStore)))

const compact = computed(() => Boolean(globalStore.sidebar?.compact))

function toggleCompact() {
  if (!globalStore.sidebar) return

  const next = !globalStore.sidebar.compact
  globalStore.sidebar.compact = next
  saveToStorage(SIDEBAR_VIEW_MODE_KEY, next)
}

function toggleGroup(item) {
  item.expanded = !item.expanded
}
</script>
